/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MailMagazineManagementFileUploadDTO } from './MailMagazineManagementFileUploadDTO';

export type MailMagazineManagementCreateMailMagazineRequest = {
    type: MailMagazineManagementCreateMailMagazineRequest.type;
    title: string;
    title_en?: string;
    title_cn?: string;
    context: string;
    context_en?: string;
    context_cn?: string;
    plain_context: string;
    plain_context_en?: string;
    plain_context_cn?: string;
    post_date?: string | null;
    open_status: MailMagazineManagementCreateMailMagazineRequest.open_status;
    release_setting?: MailMagazineManagementCreateMailMagazineRequest.release_setting;
    upload_files?: Array<MailMagazineManagementFileUploadDTO>;
    is_test?: boolean;
};

export namespace MailMagazineManagementCreateMailMagazineRequest {

    export enum type {
        ALL = 'all',
        CONSUMER = 'consumer',
        BUSINESS = 'business',
        MANIA = 'mania',
    }

    export enum open_status {
        EDIT = 'edit',
        SEND = 'send',
    }

    export enum release_setting {
        NOW = 'now',
        DATE = 'date',
    }


}

